import Swal from "sweetalert2";

export const handleDeleteConfirmation = async ({
  dispatch,
  id,
  setRefetch,
  deleteAction,
}) => {
  try {
    const result = await Swal.fire({
      title: 'Apakah anda yakin?',
      text: 'Anda tidak dapat mengembalikan data yang telah dihapus!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
    });

    if (!result.isConfirmed) return;

    const actionResult = await dispatch(deleteAction(id));

    // Hanya tampilkan modal sukses jika thunk benar-benar fulfilled.
    if (deleteAction.fulfilled.match(actionResult)) {
      setRefetch(prevRefetch => !prevRefetch);

      Swal.fire(
        'Terhapus!',
        'Data telah dihapus.',
        'success'
      );
    }
  } catch (error) {
    console.error('Delete error:', error);
  }
};